import { DocumentMetadata } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const uploadSupportingDocument: (
  fetchContext: FetchContext,
  nominationId: number,
  documentContent: File,
  accessToken?: string,
) => Promise<DocumentMetadata> = (fetchContext, nominationId, documentContent, accessToken) => {
  const formData = new FormData();
  formData.append('documentUploadRequest', documentContent);

  return fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}/supporting-documents`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: formData,
  }).then((response) => responseErrorHandler<DocumentMetadata>(fetchContext.errorStore, response, 'upload supporting document'));
};
